import { motion } from "framer-motion";

interface ShadowBackgroundProps {
	onClick: () => void;
	theme?: { opacity?: number; blur?: boolean };
}

const ShadowBackground = ({ onClick, theme }: ShadowBackgroundProps) => {
	return (
		<>
			<motion.div
				{...{ onClick }}
				className={`bg-dark fixed inset-0 z-[98] ${
					theme?.blur && "backdrop-blur"
				}`}
				initial={{ opacity: 0 }}
				animate={{ opacity: theme?.opacity || 0.4 }}
				exit={{ opacity: 0 }}
			/>
			{theme?.blur && (
				<div className="fixed inset-0 backdrop-blur-sm  z-[97]"></div>
			)}
		</>
	);
};

export default ShadowBackground;
